import { Component } from '@angular/core';
import { InvoiceGstHeaderComponent } from '../sells-panel/invoice-gst-header/invoice-gst-header.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-gst-layout',
  imports: [InvoiceGstHeaderComponent,RouterOutlet],
  templateUrl: './gst-layout.component.html',
  styleUrl: './gst-layout.component.css'
})
export class GstLayoutComponent {

}
